import { render, staticRenderFns } from "./hanhvi.vue?vue&type=template&id=4672ce8b"
import script from "./hanhvi.vue?vue&type=script&lang=js"
export * from "./hanhvi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports